import { reportDetailedNotesTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_DETAILED_NOTES_FILTERS,
  RESTORE_INITIAL
} = reportDetailedNotesTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportDetailedNotesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DETAILED_NOTES_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
